import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Heart, LayoutGrid, ShoppingBag, Shield, User } from 'lucide-react';
import { useApp } from '../../context/AppContext';

const TABS = [
  { path: '/', label: 'Каталог', Icon: LayoutGrid },
  { path: '/favorites', label: 'Избранное', Icon: Heart },
  { path: '/cart', label: 'Корзина', Icon: ShoppingBag },
  { path: '/profile', label: 'Профиль', Icon: User },
  { path: '/admin', label: 'Админ', Icon: Shield },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, favorites, cartCount } = useApp();

  const visibleTabs = user?.is_admin ? TABS : TABS.filter(t => t.path !== '/admin');

  const counts = {
    '/': 0,
    '/favorites': favorites.length,
    '/cart': cartCount,
    '/profile': 0,
    '/admin': 0,
  };

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-border-warm bg-cream/85 backdrop-blur-xl">
      <ul className={`mx-auto grid max-w-md ${visibleTabs.length === 5 ? 'grid-cols-5' : 'grid-cols-4'}`}>
        {visibleTabs.map(({ path, label, Icon }) => {
          const active = path === '/admin'
            ? location.pathname.startsWith('/admin')
            : location.pathname === path;
          const count = counts[path];
          return (
            <li key={path}>
              <button
                onClick={() => navigate(path)}
                className={`relative flex w-full flex-col items-center gap-1 py-2.5 text-xs transition ${
                  active
                    ? 'text-green-primary'
                    : 'text-green-muted hover:text-green-dark'
                }`}
              >
                <span className="relative">
                  <Icon
                    className={`h-6 w-6 transition-transform ${active ? 'scale-110' : ''}`}
                    strokeWidth={active ? 2.4 : 2}
                  />
                  {count > 0 && (
                    <span className="absolute -right-2 -top-1.5 grid min-w-[18px] place-items-center rounded-full bg-terracotta px-1 text-[10px] font-bold text-white shadow ring-2 ring-cream">
                      {count > 99 ? '99+' : count}
                    </span>
                  )}
                </span>
                <span className={`font-medium ${active ? 'font-semibold' : ''}`}>
                  {label}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}
